export default __webpack_public_path__ + "static/media/eniviro_logo.c2846a31.gif";